import i18next from "i18next";

const t = (key: string, params?: object): string => i18next.t(key, { ns: "admin", ...params }) as string;

const value = (text: string): string => (text === "brak" ? t("orders.systemComments.none") : text);

const changePatterns: { pattern: RegExp; key: string }[] = [
  { pattern: /^Zmiana ceny netto zamówienia z (.+) na (.+)$/, key: "orders.systemComments.priceChange" },
  { pattern: /^Zmiana tonażu zrealizowanego zamówienia z (.+) na (.+)$/, key: "orders.systemComments.tonnageChange" },
  { pattern: /^Zmiana daty realizacji zrealizowanego zamówienia z (.+) na (.+)$/, key: "orders.systemComments.receivingDateChange" },
];

const fixedComments: { [content: string]: string } = {
  "Edycja podziału zamówienia CUO - zmieniono parametry zamówienia": "orders.systemComments.cuoSplitEdited",
  "Nowe zamówienie utworzone z podziału CUO": "orders.systemComments.cuoSplitCreated",
};

export const translateOrderComment = (content: string): string => {
  if (!content) {
    return content;
  }
  if (fixedComments[content] !== undefined) {
    return t(fixedComments[content]);
  }
  for (const { pattern, key } of changePatterns) {
    const match = content.match(pattern);
    if (match) {
      return t(key, { from: value(match[1]), to: value(match[2]) });
    }
  }
  return content;
};
